<div class="item-container">
  <div class="audits">
    Audit trail...
  </div>
</div>